import React, { Fragment, useEffect, useState, useRef } from 'react';
import moment from 'moment';
import Img from '../components/Img';
import { isVideo, openNotificationInToast, SpinLoader } from '../utilities';
import { webinarShareImg } from '../utilities/resources';
import ReadMore from '../components/ReadMore';
import Experts from '../components/Experts';
import { webinarsListService } from '../services/apiServices';
import EmptyAlert from '../components/EmptyAlert';
import { useDispatch, useSelector } from 'react-redux';
import { isAuthenticated } from '../utilities';
import { INITIATE_AUTH_DRAWER } from '../actions/types';
import { redirectToOmnicuris } from '../utilities';
import MetaDecorators from '../components/MetaDecorators';
import { FaCircle } from 'react-icons/fa';

function WebinarsLanding() {
  const { domainDetails } = useSelector((state) => state.listings);
  const [isLoading, setIsLoading] = useState(true);
  const [pastWebinarList, setPastWebinarList] = useState([]);
  const [liveWebinarList, setLiveWebinarList] = useState([]);
  const [futureWebinarList, setFutureWebinarList] = useState([]);

  const boxRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsLoading(true);
    if (domainDetails && domainDetails.id) {
      webinarsListService(domainDetails.id)
        .then((response) => {
          if (response) {
            setPastWebinarList(response.recentlyCompleted);
            setLiveWebinarList(response.liveWebinars);
            setFutureWebinarList(response.upcomingWebinars);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  }, [domainDetails]);

  const calcMaxLength = () => {
    return window.innerWidth <= 1180 || window.innerWidth >= 1380 ? 110 : 85;
  };

  const calcTitleMaxLength = (title) => {
    return (window.innerWidth <= 1180 && window.innerWidth >= 890) || window.innerWidth <= 752
      ? title.length
      : window.innerWidth >= 1380 || (window.innerWidth < 890 && window.innerWidth > 752) || (window.innerWidth < 1380 && window.innerWidth > 1180)
      ? 50
      : title.length;
  };

  const handleShare = (webinar) => {
    navigator.clipboard.writeText(webinar.webinarLandingUrl);
    openNotificationInToast('success', 'Link Copied!', 'The webinar link has been copied to your clipboard!');
  };

  const goToWebinarLanding = (webinar) => {
    window.open(webinar.webinarLandingUrl);
  };

  const handleOnClickOnly = (ev, webinar) => {
    ev.stopPropagation();
    if (!isAuthenticated()) {
      dispatch({
        type: INITIATE_AUTH_DRAWER,
      });
    } else {
      goToWebinarLanding(webinar);
    }
  };

  const webinarCard = (webinar, index) => (
    <div key={index} className={'webinarCard fadeInUp'} style={{ animationDelay: `${index * 0.15}s` }}>
      <div className={'webinarMedia'}>
        <Img
          src={
            webinar.webinarThumbnail && !isVideo(webinar.webinarThumbnail)
              ? webinar.webinarThumbnail
              : webinar.webinarImage && !isVideo(webinar.webinarImage)
              ? webinar.webinarImage
              : webinar.webinarThumbnail
              ? webinar.webinarThumbnail
              : webinar.parentThumbnail
          }
          defaultSrc={''}
          alt={webinar.topicName}
        />
      </div>
      <div className={'rightSection'}>
        <div className={'firstRow'}>
          <div className={'webinarTime'}>
            {webinar.hasWebinarHappened
              ? `Streamed on ${moment(new Date(webinar.webinarLaunchTime)).format('Do MMM yyyy')}`
              : moment(new Date(webinar.webinarLaunchTime)).format(
                  window.innerWidth <= 700 || (window.innerWidth >= 1180 && window.innerWidth <= 1380) ? 'ddd, Do MMM, h:mm A' : 'dddd, Do MMMM, h:mm A'
                )}
          </div>
          <div onClick={() => handleShare(webinar)} className={'share'}>
            <img style={{ marginTop: '5px' }} src={webinarShareImg} width='14px' height='13px' alt='Share Webinar' />
            <span className={'shareText'}>Share</span>
          </div>
        </div>
        <div className={'mainTitle'}>
          {webinar.topicName && webinar.topicName.length > calcTitleMaxLength(webinar.topicName) ? webinar.topicName.substr(0, calcTitleMaxLength(webinar.topicName)) + '...' : webinar.topicName}
        </div>
        <div className={'description'}>
          <ReadMore charLimit={calcMaxLength()} content={webinar.description} readMoreClickAction={goToWebinarLanding} contentInAction={webinar} />
        </div>
        <div className={'lastRow'}>
          <div ref={boxRef} className='expertBox'>
            {webinar.experts && webinar.experts.length > 0 && <Experts data={webinar.experts} containerRef={boxRef} />}
          </div>
          <button onClick={(ev) => handleOnClickOnly(ev, webinar)} className={'buttonWebinar'}>
            {webinar.buttonTitle}
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className={'webinarListPage'}>
      <MetaDecorators />
      {isLoading ? (
        <div className='loader'>
          <SpinLoader />
        </div>
      ) : pastWebinarList.length === 0 && futureWebinarList.length === 0 ? (
        <EmptyAlert />
      ) : (
        <Fragment>
          {liveWebinarList && liveWebinarList.length > 0 && (
            <div>
              <div className={'sectionTitle'}>Upcoming Webinars</div>
              <div className={'webinarCardGrid'}>
                {liveWebinarList.map((webinar, index) => {
                  return webinarCard(webinar, index);
                })}
              </div>
            </div>
          )}
          {futureWebinarList && futureWebinarList.length > 0 && (
            <div>
              <div className={'sectionTitle'}>Upcoming Webinars</div>
              <div className={'webinarCardGrid'}>
                {futureWebinarList.map((webinar, index) => {
                  return webinarCard(webinar, index);
                })}
              </div>
            </div>
          )}
          {pastWebinarList && pastWebinarList.length > 0 && (
            <div>
              <div className={'sectionTitle'}>Recently Completed</div>
              <div className={'webinarCardGrid'}>
                {pastWebinarList.map((webinar, index) => {
                  return webinarCard(webinar, index);
                })}
              </div>
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
}

export default WebinarsLanding;
